module.exports = __webpack_public_path__ + "img/banner-ru10x20.29496675.jpg";